module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><defs><style>.a{fill:#fff;}.b{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}</style></defs><title>IG</title><circle cx=\"25\" cy=\"25\" r=\"24\"></circle><rect class=\"a\" x=\"13.98\" y=\"14.31\" width=\"22.1\" height=\"22.1\" rx=\"5.12\" ry=\"5.12\"></rect><circle class=\"b\" cx=\"25.02\" cy=\"25.36\" r=\"4.14\"></circle><circle cx=\"30.4\" cy=\"17.81\" r=\"1.48\"></circle></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/instagram.svg
// module id = 548
// module chunks = 1